import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface IphoneValidation {
  Length: number;
  Start: number;
  Code: string;
  CountryId: number;
}

const initialState: IphoneValidation = {
  Length: 1,
  Start: 0,
  Code: "",
  CountryId: 0,
};

const phoneValidationSlice = createSlice({
  name: "PhValidation",
  initialState,
  reducers: {
    setValidationVal(state, action: PayloadAction<IphoneValidation>) {
      state.Length = action.payload.Length;
      state.Start = action.payload.Start;
      state.Code = action.payload.Code;
      state.CountryId = action.payload.CountryId;
    },
  },
});

export const { setValidationVal } = phoneValidationSlice.actions;
export default phoneValidationSlice.reducer;
